import type { ProductTypeOptions } from '@/types/product';

import BucklePlaceholderImage from '@/assets/buckle-placeholder.svg';
import GenericPlaceholderImage from '@/assets/generic-placeholder.svg';
import StrapPlaceholderImage from '@/assets/strap-placeholder.svg';
import WatchPlaceholderImage from '@/assets/watch-placeholder.svg';

export const getProductPlaceholderImage = (
  productType?: ProductTypeOptions,
) => {
  switch (productType) {
    case 'watch':
      return WatchPlaceholderImage;

    case 'strap':
      return StrapPlaceholderImage;

    case 'buckle':
      return BucklePlaceholderImage;

    default:
      return GenericPlaceholderImage;
  }
};
